import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { OrderProvider } from "@/state/OrderContext";
import { AdminAuthProvider } from "@/state/AdminAuthContext";
import { AdminProtectedRoute } from "@/components/admin/AdminProtectedRoute";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import HomePage from "@/pages/HomePage";
import DesignPage from "@/pages/DesignPage";
import TempahPage from "@/pages/TempahPage";
import SemakPage from "@/pages/SemakPage";
import BayaranHasilPage from "@/pages/BayaranHasilPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminOrdersPage from "@/pages/admin/AdminOrdersPage";
import AdminOrderDetailPage from "@/pages/admin/AdminOrderDetailPage";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";

function PublicApp() {
  return (
    <OrderProvider>
      <Outlet />
    </OrderProvider>
  );
}

function AdminApp() {
  return (
    <AdminAuthProvider>
      <Outlet />
    </AdminAuthProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<PublicApp />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/design" element={<DesignPage />} />
          <Route path="/tempah" element={<TempahPage />} />
          <Route path="/semak" element={<SemakPage />} />
          <Route path="/bayaran/hasil" element={<BayaranHasilPage />} />
        </Route>
        <Route element={<AdminApp />}>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<Navigate to="/admin/orders" replace />} />
          <Route
            path="/admin/orders"
            element={
              <AdminProtectedRoute>
                <AdminOrdersPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/orders/:orderReference"
            element={
              <AdminProtectedRoute>
                <AdminOrderDetailPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <AdminProtectedRoute>
                <AdminSettingsPage />
              </AdminProtectedRoute>
            }
          />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
